<div class="bg-white rounded-md">
  <div *ngIf="config.search">
    <div class="max-w-[700px] mx-auto mb-3 p-4">
      <app-input
        [config]="{
          placeholder: config.search.searchPlaceholder || 'Search by keyword',
          label: config.search.searchPlaceholder || 'Search by keyword',
          inputType: InputType.text,
          inputClass: 'border border-black !rounded-[24px]'
        }"
        [formControl]="searchControl"
      ></app-input>
    </div>
  </div>
  <div class="table-responsive hidden md:block">
    <table class="table">
      <thead class="bg-none">
        <tr class="bg-white text-black">
          <th>S/N</th>

          <th scope="col" *ngFor="let col of headers">
            {{ col | titlecase }}
          </th>
          <th scope="col" *ngIf="showOptionHeader"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let item of data
              | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: pagination?.page,
                    totalItems: pagination?.totalItems
                  };
            let first = first;
            let isLast = last;
            let i = index
          "
          (click)="onRowSelect(item)"
        >
          <td>
            {{ i + serialNumberCounter }}
          </td>

          <td
            *ngFor="let row of config.rows; let first = first"
            [class]="row.classes"
          >
            <ng-container [ngSwitch]="row?.type">
              <span
                *ngSwitchCase="'badge'"
                [class]="row.classes + ' ' + 'badge-' + item[row.prop]"
              >
                {{ item[row.prop] || "---" }}
              </span>

              <span [class]="row.classes" *ngSwitchCase="'amount'">
                {{ item[row.prop] | amount }}
              </span>

              <span [class]="row.classes" *ngSwitchDefault>
                {{ item[row.prop] || "---" }}
              </span>
            </ng-container>
          </td>

          <td *ngIf="anyMenu">
            <button *ngIf="tableHasOptions || item?.menu?.length">
              <div
                class="md:py-[12px] md:px-6 cursor-pointer flex justify-end items-center md:text-dark text-sm"
                (click)="onOpenOptionsMenu(item, $event)"
              >
                <ion-icon name="ellipsis-vertical"></ion-icon>
              </div>
            </button>
          </td>
          <td *ngIf="!config.options && config.rowActionable">
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div
  class="overflow-x-auto rounded-none md:rounded-md md:bg-white md:pb-5 md:hidden"
  *ngIf="data?.length"
>
  <div
    class="md:flex mb-3 md:mb-0 rounded-md md:rounded-none bg-white px-4 md:px-0 py-4 md:py-0 shadow-sm md:shadow-none"
    *ngFor="
      let item of data
        | paginate
          : {
              itemsPerPage: itemsPerPage,
              currentPage: pagination?.page,
              totalItems: pagination?.totalItems
            };
      let first = first;
      let isLast = last
    "
    [ngClass]="{ 'border-b border-gray-200': !isLast }"
    (click)="onRowSelect(item)"
  >
    <div
      class="w-full flex md:block justify-between py-2 md:py-0 border-b-1 md:border-b-0 border-b-white"
      *ngFor="let row of config.rows"
    >
      <div
        class="md:py-[24px] bg-offWhite md:px-6 md:border-b md:border-gray-200"
        [ngClass]="[!first ? 'md:hidden' : '']"
      >
        <span class="head block text-sm text-dark font-semibold">{{
          row.header | titlecase
        }}</span>
      </div>

      <div
        class="md:py-[12px] md:px-6 cursor-pointer text-right md:text-left text-purple md:text-dark text-sm"
      >
        <span class="block {{ row.classes }}">{{
          item[row.prop] || "---"
        }}</span>
      </div>
    </div>

    <div
      class="w-full flex md:block justify-between py-2 md:py-0 border-b-1 md:border-b-0 border-b-white"
      *ngIf="tableHasOptions || item?.menu?.length"
    >
      <div
        class="md:py-[24px] bg-offWhite md:px-6 md:border-b md:border-gray-200"
        [ngClass]="[!first ? 'md:hidden' : '']"
      >
        <span class="head block text-sm text-dark font-semibold">options</span>
      </div>

      <div
        class="md:py-[12px] md:px-6 cursor-pointer flex justify-end items-center md:text-dark text-sm"
        (click)="onOpenOptionsMenu(item, $event)"
      >
        <ion-icon name="ellipsis-vertical"></ion-icon>
      </div>
    </div>
  </div>
</div>

<!-- <app-shimmer
  [loaderType]="loaderType"
  [shimmerSize]="shimmerSize"
  *ngIf="loading && data && data.length === 0"
></app-shimmer> -->

<!-- <app-empty-data
  *ngIf="dataList && dataList.length == 0 && !loading"
  [message]="emptyMessage"
  [showImage]="config.showEmptyStateImage"
></app-empty-data> -->

<pagination-controls
  *ngIf="!config.hidePaginator"
  (pageChange)="changePage($event)"
></pagination-controls>
<div
  class="py-[100px] text-center text-dark rounded-xl bg-offWhite"
  [ngClass]="{ 'py-[20px]': emptySm }"
  *ngIf="data && !data.length && !loading"
>
  {{ emptyMessage }}
</div>
